import { instance } from "api/apiBase";
import { AxiosError } from "axios";

interface CodeboxStatusResponse {
  connected: boolean;
}

export interface CodeboxLockbox {
  serial_number: string;
  exists_in_boom: boolean;
}

export type BulkImportStatus =
  | { status: "not_started" }
  | { status: "pending" }
  | {
      status: "done";
      imported_count: number;
      skipped_count: number;
      failed_count: number;
    }
  | { status: "failed"; error: string };

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/codebox";

const handleCodeboxError = (error: unknown): never => {
  const axiosError = error as AxiosError;
  if (axiosError.response?.status === 422)
    throw new Error(
      "Connection failed. Please check your credentials and try again."
    );
  throw error;
};

export const codeboxApi = {
  getStatus: async (): Promise<CodeboxStatusResponse> => {
    const { data } =
      await instance.get<CodeboxStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (payload: {
    username: string;
    password: string;
  }): Promise<CodeboxStatusResponse> => {
    try {
      const { data } = await instance.post<CodeboxStatusResponse>(
        BASE_ENDPOINT_URL,
        payload
      );
      return data;
    } catch (error) {
      return handleCodeboxError(error);
    }
  },

  disconnect: async (): Promise<CodeboxStatusResponse> => {
    const { data } =
      await instance.delete<CodeboxStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  getLockboxes: async (): Promise<CodeboxLockbox[]> => {
    const { data } = await instance.get<CodeboxLockbox[]>(
      `${BASE_ENDPOINT_URL}/lockboxes`
    );
    return data;
  },

  bulkImportLockboxes: async (serial_numbers: string[]): Promise<void> => {
    await instance.post(`${BASE_ENDPOINT_URL}/lockboxes/bulk_import`, {
      serial_numbers
    });
  },

  getBulkImportStatus: async (): Promise<BulkImportStatus> => {
    const { data } = await instance.get<BulkImportStatus>(
      `${BASE_ENDPOINT_URL}/lockboxes/bulk_import_status`
    );
    return data;
  }
};
